export default {
  SHOW_TOAST: 'MESSAGE/SHOW_TOAST',
  CLOSE: 'MESSAGE/CLOSE',
}
